import { getAchievement, type SessionSummary } from '@tm/shared';
import { Confetti } from '../components/Confetti.js';
import { plural } from './Home.js';

/** Оценка старается быть доброй: даже слабый результат заканчивается «попробуй ещё». */
function verdict(s: SessionSummary): { emoji: string; title: string; note: string } {
  const acc = s.accuracy;
  if (s.total === 0) return { emoji: '🤔', title: 'Ни одного ответа', note: 'Попробуй ещё раз!' };
  if (acc === 1) return { emoji: '🌟', title: 'Идеально!', note: 'Ни одной ошибки — вот это класс' };
  if (acc >= 0.8) return { emoji: '🎉', title: 'Отлично!', note: 'Почти всё верно' };
  if (acc >= 0.6) return { emoji: '👍', title: 'Хорошо', note: 'Ещё чуть-чуть — и будет отлично' };
  return { emoji: '💪', title: 'Есть над чем поработать', note: 'Сложные примеры вернутся в следующий раз' };
}

export function Result({ summary, onAgain, onHome }: {
  summary: SessionSummary;
  onAgain: () => void;
  onHome: () => void;
}) {
  const v = verdict(summary);
  const celebrate = summary.accuracy >= 0.8 || summary.isRecord || summary.unlocked.length > 0;

  return (
    <div className="stack">
      <Confetti run={celebrate} />

      <div className="card center pop">
        <div style={{ fontSize: 52, lineHeight: 1.1 }}>{v.emoji}</div>
        <h1>{v.title}</h1>
        <p className="dim small" style={{ margin: '4px 0 0' }}>{v.note}</p>
        {summary.isRecord && <p className="pill win" style={{ marginTop: 10 }}>🏆 Новый рекорд!</p>}
      </div>

      <div className="tiles">
        <div className="tile">
          <div className="v">{summary.correct} / {summary.total}</div>
          <div className="k">верных ответов</div>
        </div>
        <div className="tile">
          <div className="v">{Math.round(summary.accuracy * 100)}%</div>
          <div className="k">точность</div>
        </div>
        <div className="tile">
          <div className="v">{(summary.avgMs / 1000).toFixed(1)} с</div>
          <div className="k">среднее время</div>
        </div>
        <div className="tile">
          <div className="v">{summary.score}</div>
          <div className="k">очков</div>
        </div>
      </div>

      {summary.bestCombo >= 3 && (
        <p className="center small dim">
          Лучшая серия: {summary.bestCombo} {plural(summary.bestCombo, 'ответ', 'ответа', 'ответов')} подряд 🔥
        </p>
      )}

      {summary.unlocked.length > 0 && (
        <div className="card">
          <h3>Новые награды</h3>
          {summary.unlocked.map((code) => {
            const a = getAchievement(code);
            if (!a) return null;
            return (
              <div className="ach pop" key={code}>
                <span className="ico">{a.emoji}</span>
                <span className="grow">
                  <b>{a.title}</b>
                  <div className="small dim">{a.description}</div>
                </span>
              </div>
            );
          })}
        </div>
      )}

      <button className="btn" onClick={onAgain}>Ещё раз</button>
      <button className="btn ghost" onClick={onHome}>На главную</button>
    </div>
  );
}
